/* istanbul ignore file */
import Footer from './Footer';

export default Footer;
